<template>
  <div id="app">
    <router-view :key="key" />
    <winSizeChange />

    <!-- <Modal
      v-model="hasNoPhone"
      :closable="false"
      :footer-hide="true"
      :mask-closable="false"
      :width="550"
    >
      <CompletePhone @cancelHandler="closeNoPhoneModal" v-if="hasNoPhone" />
    </Modal> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import winSizeChange from '@/pages/Common/winSizeChange';
export default {
  name: 'App',
  computed: {
    ...mapState({
      appSpinShow: state => state.app.appSpinShow
    }),
    key () {
      if ('/open/default'.indexOf(this.$route.path) > -1) {
        return this.$route.path + Math.random()
      } else {
        return ''
      }
    }
  },
  components: {
    winSizeChange,
    CompletePhone: () => import('@/pages/Layout/CompletePhone.vue')
  },
  data () {
    return {
      hasNoPhone: false
    }
  },
  methods: {
    // 关闭弹窗
    closeNoPhoneModal () {
      this.hasNoPhone = false;
      localStorage.removeItem('hasNoPhoneFlag');
      location.reload();
    },

    // 验证当前账户 是否有绑定手机号 没有就弹窗
    checkAccoutInfo () {
      fetch('/user/v4/domain/account/status/info')
        .then(response => response.json())
        .then(res => {
          // 需求0611：去除手机号绑定弹窗功能
          // if (res && res.data && !res.data.hasPhone && res.data.hasPhone !== undefined) {
          //   this.hasNoPhone = true;
          //   localStorage.setItem('hasNoPhoneFlag', true);
          // }
        })
        .catch(error => {
          console.error('Error:', error);
          if(localStorage.getItem('hasNoPhoneFlag') !== undefined) {
            localStorage.removeItem('hasNoPhoneFlag');
          }
        });
    }
  },
  mounted () {
    // 如果有用户信息，直接跳到  首页
    if (localStorage.userToken) {
      this.$cookies.set('access_token', localStorage.userToken);
    }

    // hasNoPhoneFlag 用于其他地方也有判断 防止多次判断出现多个弹窗
    if (this.$cookies.get('token') && !location.href.includes('/login') && !localStorage.hasNoPhoneFlag) {
      this.checkAccoutInfo();
    }

    if (window.performance.navigation.type === 0) {
    } else {
      localStorage.removeItem('hasNoPhoneFlag');
    }
    window.onbeforeunload = () => {
      localStorage.removeItem('hasNoPhoneFlag');
    };
  }
};
</script>

<style lang="less">
@media screen and(max-width: 900px) {
  #app {
    width: 1300px;
    height: 735px !important;
  }
}
.page-bg {
  height: 100%;
  background-color: #132a60;
  background-image: url('~assets/images/bg.jpg');
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.app-spin {
  background-color: rgba(0, 0, 0, 0.7) !important;
  z-index: 9999 !important;
}

.spin-icon-load {
  font-size: 28px !important;
  animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
